import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home/Home';
import ProductPage from './components/Product/ProductPage';
import AboutUs from './components/About/AboutUs';
import Pricing from './components/Pricing/Pricing';
import Login from './components/Login/Login';
import Blog from './components/Blog/Blog';
import BlogDetail from './components/Blog/BlogDetail';
import Dashboard from './components/Dashboard/Dashboard';
import { ProtectedRoute } from './components/ProtectedRoute';

function App() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/dashboard');

  return (
    <AuthProvider>
      <div className={`App ${isDashboard ? 'bg-white' : 'bg-black'}`}>
        {!isDashboard && <Header />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        {!isDashboard && <Footer />}
      </div>
    </AuthProvider>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
